
import { saleOrder } from "@gtpl/shared-services/sale-management";
import { CycleChecker } from "../cycle-checker.entity";
import { CycleCheckerDTO } from "./cycle-checker.dto";

export class CycleCheckerAdapter{
    convertDtoToEntity(dtoObj:CycleCheckerDTO,isUpdate: boolean = false):CycleChecker{

         const entityObj = new CycleChecker();
         entityObj.cycleCheckerId = dtoObj.cycleCheckerId;
         entityObj.itemCategoryId = dtoObj.itemCategoryId;
         entityObj.itemSubCategoryId = dtoObj.itemSubCategoryId;
         entityObj.itemId = dtoObj.itemId;  
         entityObj.saleOrderId = 0;
         entityObj.masterBrandId = dtoObj.masterBrandId;
         entityObj.physicalQuantity = dtoObj.physicalQuantity;
         entityObj.status = dtoObj.status;
         entityObj.unitId = dtoObj.unitId;
         entityObj.createdAt = dtoObj.createdAt;
         entityObj.updatedAt = dtoObj.updatedAt;
         entityObj.createdUser = dtoObj.createdUser;
         entityObj.updatedUser = dtoObj.updatedUser;
         entityObj.versionFlag = dtoObj.versionFlag;
         entityObj.locationId = dtoObj.locationId;
         entityObj.reason = dtoObj.reason;
         entityObj.previousQuantity = dtoObj.previousQuantity;
         return entityObj;
       
    }
    public convertEntityToDto(obj:CycleChecker) :CycleCheckerDTO{

        const dtoObj = new CycleCheckerDTO;

        dtoObj.cycleCheckerId = obj.cycleCheckerId; 
        dtoObj.itemCategoryId = obj.itemCategoryId;
        dtoObj.itemSubCategoryId = obj.itemSubCategoryId;
        dtoObj.itemId = obj.itemId;
        dtoObj.saleOrderId = obj.saleOrderId;
        dtoObj.masterBrandId = obj.masterBrandId;
        dtoObj.physicalQuantity = obj.physicalQuantity;
        dtoObj.status = obj.status;
        dtoObj.unitId = obj.unitId;
        dtoObj.createdAt = obj.createdAt;
        dtoObj.updatedAt = obj.updatedAt;
        dtoObj.createdUser = obj.createdUser;
        dtoObj.updatedUser = obj.updatedUser;
        dtoObj.versionFlag = obj.versionFlag;
        dtoObj.locationId = obj.locationId;
        dtoObj.reason = obj.reason;
        dtoObj.previousQuantity = obj.previousQuantity;
        return dtoObj;

    }
}